import { actionTypes, UserEntersHouseNumber } from "./Actions";

const userEntersHouseNumber: UserEntersHouseNumber = (
  houseNumber: string
) => ({
  houseNumber,
  type: actionTypes.USER_ENTERS_HOUSE_NUMBER
});

export default userEntersHouseNumber;
